import script from "./FormMovimentacaoDevolucaoFornecedor.vue?vue&type=script&setup=true&lang=js"
export * from "./FormMovimentacaoDevolucaoFornecedor.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__